export const MD_BREAKPOINT = 768;
export const LG_BREAKPOINT = 1024;
